module.exports = __webpack_public_path__ + "assets/img/masterpass.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/masterpass.svg
// module id = 34
// module chunks = 0